import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';

export type InputType = { kind: 'eurotax' | 'plate' | 'constructor_code' | string; value: string };

export type ValidateInput = (s: string) => E.Either<string, InputType>;

const maybeEuroTax: ValidateInput = (s: string) =>
  s.length === 7 && !isNaN(parseInt(s)) ? E.right({ kind: 'eurotax', value: s }) : E.left('Not Eurotax');

const maybePlate: ValidateInput = (s: string) =>
  s.length === 7 && /([A-Z][A-Z][0-9][0-9][0-9][A-Z][A-Z]|[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9])/.test(s)
    ? E.right({ kind: 'plate', value: s })
    : E.left('Not a plate');

export const validateInput: ValidateInput = (s) =>
  pipe(
    maybeEuroTax(s),
    E.alt(() => maybePlate(s)),
    E.alt(() => E.right({ kind: 'constructor_code', value: s }))
  );

export const useFullTextValidation = (): { validate: ValidateInput } => {
  const validate: ValidateInput = (a: string) =>
    pipe(
      validateInput(a),
      E.map((x) => x)
    );

  return { validate };
};
